// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Icon} from '../../icon/Icon'
import {Tooltip} from '../../tooltip/Tooltip'

// Mixins
import {EventBus} from '../../../../mixins/event_bus/EventBus'

@Component({
    name: 'ProcessBarStep',
    components: {Icon, Tooltip},
    mixins: [
        template,
    ]
})
export class ProcessBarStep extends mixins(EventBus) {

    @Prop({default: false})
    public forceA!: boolean

    @Prop()
    public active!: boolean

    @Prop()
    public disabled!: boolean

    @Prop()
    public warning!: boolean

    @Prop()
    public error!: boolean

    @Prop()
    public stop!: boolean

    @Prop()
    public text!: string

    @Prop()
    public href!: string

    @Prop()
    public to!: object

    @Prop()
    public icon!: string

    @Prop()
    public iconFile!: string

    @Prop({default:true})
    public inArrow!: boolean

    @Prop({default:true})
    public outArrow!: boolean

    public created () {

    }

    public destroyed() {

    }
}